var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteEmployee({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.992,
    height: 18.63,
    viewBox: "0 0 16.992 18.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Button_Icon_Round",
    "data-name": "Button/Icon/Round",
    transform: "translate(61.517 -29.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "action_icon-round-button",
    "data-name": "action/icon-round-button",
    transform: "translate(-91.667 0.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash-2",
    transform: "translate(31 30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0,0H15.292",
    transform: "translate(0 3.386)",
    fill: "none",
    stroke: "#4b5960",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M10.195,16.93H1.7A1.7,1.7,0,0,1,0,15.237V3.386H2.549V1.693A1.7,1.7,0,0,1,4.248,0h3.4a1.7,1.7,0,0,1,1.7,1.693V3.386h2.549V15.237A1.7,1.7,0,0,1,10.195,16.93Z",
    transform: "translate(1.699 0)",
    fill: "none",
    stroke: "#4b5960",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M0,0V5.079",
    transform: "translate(5.947 7.619)",
    fill: "none",
    stroke: "#4b5960",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M0,0V5.079",
    transform: "translate(9.345 7.619)",
    fill: "none",
    stroke: "#4b5960",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteEmployee);
export default __webpack_public_path__ + "static/media/delete_employee.71d7f60ffa4164abb88aca7fb046e04e.svg";
export { ForwardRef as ReactComponent };